define([
    'jquery',

    'qrcode'
], function(
    $
){
    return {
        template: '<span class="u-qrcode"></span>',
        props: {
            url: {
                type: String
            }
        },
        watch: {
            url: 'updateQrcode'
        },
        methods: {
            updateQrcode: function(){
                $(this.$el).empty().qrcode({
                    width: 100,
                    height: 100,
                    text: this.url
                });
            }
        },
        mounted: function(){
            this.updateQrcode();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ../common/menu/qrcode.js
// module id = 79
// module chunks = 0 1 2 3 4 5 6 7 8